<template>
  <div class="position-relative">
    <div class="input-group">
      <input
        :value="displayedValue"
        type="text"
        class="form-control product-ids-input"
        :disabled="disabled"
        readonly
        @focus="onFocusProductIds"
      >

      <div class="input-group-append">
        <button
          class="btn btn-outline px-2"
          :disabled="disabled"
          @click="onFocusProductIds(!isShowDropdown)"
        >
          <i :class="{'cil-chevron-bottom': !isShowDropdown, 'cil-chevron-top': isShowDropdown }" />
        </button>
      </div>
    </div>

    <div
      v-show="isShowDropdown"
      class="position-absolute mt-2"
      style="z-index: 1000; width: max-content;"
    >
      <div class="file-browser-wrapper">
        <FileBrowser />
      </div>

      <div
        class="bg-white p-2 mt-1 border border-dark d-flex justify-content-end"
        style="border-radius: 20px;"
      >
        <b-button @click="isShowDropdown = false">
          Close
        </b-button>

        <b-button
          class="ml-2"
          variant="success"
          @click="handleImagesSave"
        >
          Save
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { MODES } from '@frontend/components/modules/product-list/constants';
import FileBrowser from '@frontend/components/modules/product-list/FileBrowser.vue';

export default {
  name: 'ProductImageSelect',
  components: {
    FileBrowser,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['updated-image'],
  data() {
    return {
      isShowDropdown: false,
    }
  },
  computed: {
    ...mapGetters('productImageSelector', [
      'selectedItems',
      'pickedItems',
    ]),
    displayedValue() {
      return this.value[0]?.fileId || this.value[0]?.product_name
        || this.value[0]?.name || this.value[0]?.id || '';
    },
  },
  mounted() {
    this.setOnlyOneItemSelection(true);
  },
  methods: {
    ...mapActions('productImageSelector', [
      'setMode',
      'setOnlyOneItemSelection',
      'initView',
    ]),
    onFocusProductIds(isOpen = true) {
      this.isShowDropdown = isOpen;

      if (this.isShowDropdown) {
        this.initView({ currentProductImages: this.value });
      }
    },
    handleImagesSave() {
      this.$emit('updated-image', this.selectedItems[0] ?? null);
      this.isShowDropdown = false;
    },
  },
}
</script>